import { render } from "./6-nights.vue?vue&type=template&id=0cc2b32f&scoped=true"
import script from "./6-nights.vue?vue&type=script&lang=js"
export * from "./6-nights.vue?vue&type=script&lang=js"

import "./6-nights.vue?vue&type=style&index=0&id=0cc2b32f&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc2b32f"]])

export default __exports__